import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Layout() {
  return (
    <div>
      <Navbar />
      <main className="pt-10">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
